import React from "react";

import { useLocation } from "@gatsbyjs/reach-router";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { Shadow } from "../../../utils/BreakpointHelpers";
import LinkComponent, { Link } from "../LinkComponent";
import NewHeadline from "../NewHeadline";

const Card = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: 150px;
    ${Shadow};
    ${({ theme }) => theme.breakpoints.from.small.css`
            height: 250px;
    `}
`;

const ImageWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    width: 25%;
    text-align: right;
    ${({ theme }) => theme.breakpoints.upTo.small.css`
            width: 40%;
        `}
    ${({ theme }) => theme.breakpoints.upTo.extraSmall.css`
            display: none;
        `}
`;

const TextContainer = styled.div`
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    background-color: rgb(255 255 255 / 60%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 10px;
    ${({ theme }) => theme.breakpoints.from.small.css`
            position: absolute;
            width: 50%;
            padding: 10px 20px;
        `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        width: 65%;
        background-color: transparent;
    `}
`;

const Subline = styled.p`
    color: ${({ theme }) => theme.colors.blue.toString()};
    flex-direction: column;
    font-size: 0.9rem;
    display: flex;
    ${({ theme }) => theme.breakpoints.from.small.css`
             flex-direction: row;
             font-size: 1rem;
        `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
            font-size: 1.5rem;
        `}
`;

const BottomContainer = styled.div``;

const SmallCard = ({
    name,
    subline,
    link = { href: "/", text: "Mehr erfahren" },
    src,
}) => {
    const theme = useTheme();
    const { pathname } = useLocation();
    const imgStyle = css`
        background-image: url("${src.publicURL}");
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
    `;

    const headlineStyles = css`
        font-size: 1.2rem;
        font-weight: bold;
        margin: 10px 0 0;
        line-height: 26px;

        ${theme.breakpoints.from.small.css`
             margin: 20px 0;
             font-size: 1.5rem;
        `}
        ${theme.breakpoints.from.medium.css`
             font-size: 1.8rem;
             line-height: unset;
        `}
    `;

    return (
        <Link to={link.href} state={{ from: pathname }}>
            <Card>
                <TextContainer>
                    <NewHeadline color="blue" css={headlineStyles}>
                        {name}
                    </NewHeadline>
                    <BottomContainer>
                        <Subline>
                            <span>Standort:&nbsp;</span>
                            <span>{subline}</span>
                        </Subline>
                        <LinkComponent
                            icon="arrow-right"
                            link={link}
                            fontSize="1.5rem"
                            fSSmall="1rem"
                            fSExtraSmall="1rem"
                        />
                    </BottomContainer>
                </TextContainer>
                <ImageWrapper css={imgStyle} />
            </Card>
        </Link>
    );
};

export default SmallCard;
